// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-777804e4] {\n  fill: #fff\n}\n.st47[data-v-777804e4] {\n  fill: #d0d040\n}\n.st48[data-v-777804e4] {\n  fill: #dcdc70\n}\n", ""]);
// Exports
module.exports = exports;
